import { useAtomValue } from 'jotai';

import { userAtom } from '@/stores/auth.store';

import { getRegulatoryText } from '../constants/regulatory-text';

import { WizardStepper } from './wizard-stepper';

interface WizardSidebarProps {
  currentStep?: number;
  completedSteps?: number[];
}

export function WizardSidebar({ currentStep = 1, completedSteps = [] }: WizardSidebarProps) {
  const user = useAtomValue(userAtom);
  const regulatoryText = getRegulatoryText(user?.company?.industry);

  return (
    <aside className="fixed left-0 top-16 z-10 hidden h-[calc(100vh-64px)] w-[412px] p-6 xl:block">
      <div className="rounded-[5px] bg-[#E8EBED] p-6">
        <h2 className="mb-4 text-[20px] font-semibold text-[#051923]">Client Risk Assessment</h2>
        <p className="mb-6 text-[14px] leading-relaxed text-[#051923]">{regulatoryText}</p>
        <WizardStepper currentStep={currentStep} completedSteps={completedSteps} />
      </div>
    </aside>
  );
}
